import { render, staticRenderFns } from "./IfaAdviserEnrolment.vue?vue&type=template&id=21413fbe"
import script from "./IfaAdviserEnrolment.vue?vue&type=script&lang=js"
export * from "./IfaAdviserEnrolment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports